import React from 'react';
import './Press.css';

const Press = () => {
  const pressItems = [
    {
      id: 1,
      source: 'Báo Vietnamnet',
      title: 'Gnine Solar tiên phong triển khai hệ thống điện mặt trời',
      description: 'Gnine Solar tiên phong triển khai hệ thống điện mặt trời, đồng hành cùng doanh nghiệp hướng tới phát triển bền vững, tiết kiệm.',
      image: 'https://images.unsplash.com/photo-1504711434969-e33886168f5c?ixlib=rb-4.0.3&auto=format&fit=crop&w=600&q=80',
      link: '#',
      logo: 'https://static.mediacdn.vn/web_images/logo.png'
    },
    {
      id: 2,
      source: 'Báo Nhân lực Nhân tài Việt',
      title: 'Chủ tịch Gnine chia sẻ hành trình khởi nghiệp',
      description: 'Chủ tịch Gnine chia sẻ hành trình khởi nghiệp và quan điểm về vai trò của chữ Tâm trong kinh doanh.',
      image: 'https://images.unsplash.com/photo-1553484771-371a605b060b?ixlib=rb-4.0.3&auto=format&fit=crop&w=600&q=80',
      link: '#',
      logo: null
    },
    {
      id: 3,
      source: 'Báo An Giang',
      title: 'Gnine Solar - Giải pháp điện mặt trời cho hộ gia đình',
      description: 'Gnine Solar là đơn vị cung cấp giải pháp điện mặt trời, góp phần hỗ trợ hộ gia đình và doanh nghiệp hướng đến tự chủ năng lượng.',
      image: 'https://images.unsplash.com/photo-1509391366360-2e959784a276?ixlib=rb-4.0.3&auto=format&fit=crop&w=600&q=80',
      link: '#',
      logo: null
    }
  ];

  return (
    <section id="press" className="press-section">
      <div className="container">
        <div className="section-header" data-aos="fade-up">
          <span className="section-tag">TRUYỀN THÔNG</span>
          <h2 className="section-title">BÁO CHÍ NÓI GÌ VỀ GNINE?</h2>
          <p className="section-subtitle">
            Gnine Solar được các báo đài uy tín đưa tin về hoạt động và đóng góp cho ngành năng lượng xanh
          </p>
        </div>

        <div className="press-grid">
          {pressItems.map((item, index) => (
            <div 
              key={item.id} 
              className="press-card"
              data-aos="fade-up"
              data-aos-delay={index * 100}
            >
              <div className="press-image">
                <img src={item.image} alt={item.title} />
                <div className="press-overlay">
                  <a href={item.link} className="press-link">
                    <i className="fas fa-external-link-alt"></i>
                  </a>
                </div>
              </div>
              <div className="press-content">
                <div className="press-source">
                  <i className="fas fa-newspaper"></i>
                  <span>{item.source}</span>
                </div>
                <h3 className="press-title">{item.title}</h3>
                <p className="press-description">{item.description}</p>
                <a href={item.link} className="press-read-more">
                  Đọc thêm
                  <i className="fas fa-arrow-right ms-2"></i>
                </a>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Press;